export default __webpack_public_path__ + "static/media/arrow r.344d2d78.svg";